import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function ClientRowSupportDashboard({
  clientStatus,
  firstName,
  lastName,
  primaryAddiction,
  admissionDate,
  durationOfStay,
  idClient,
  clientData,
  roomNumber,
  therapistName,
  supportWorker,
  swotDate,
  alerts,
  projectedDischarge,
  count,
}) {
  const navigate = useNavigate();
  const [flashClientStatus, setFlashClientStatus] = useState(false);
  const [flashAdmissionDate, setFlashAdmissionDate] = useState(false);
  const [flashRoomNumber, setFlashRoomNumber] = useState(false);
  const [flashTherapistName, setFlashTherapistName] = useState(false);
  const [flashSupportWorker, setFlashSupportWorker] = useState(false);
  const [flashProjectedDischarge, setFlashProjectedDischarge] = useState(false);
  const [, setFlashPrimaryAddiction] = useState(false);
  const [flashDurationOfStay, setFlashDurationOfStay] = useState(false);
  const [flashSwotDate, setFlashSwotDate] = useState(false);
  const [, setFlashAlerts] = useState(false);
  const [shouldNavigate, setShouldNavigate] = React.useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [flashTherapistAppointment, setFlashTherapistAppointment] =
    useState(false);
  const [flashSupportWorkerAppointment, setFlashSupportWorkerAppointment] =
    useState(false);
  const [flashMedicalAppointment, setFlashMedicalAppointment] = useState(false);
  const [flashVisaAppointment, setFlashVisaAppointment] = useState(false);
  const [flashStepsAppointment, setFlashStepsAppointment] = useState(false);
  const [flashMassageDay, setFlashMassageDay] = useState(false);
  const isPhilippinesRehab =
    clientData?.rehabId === "miracles_asia_philippines" ||
    clientData?.rehabCountry === "Philippines";
  const displayClientStatus =
    isPhilippinesRehab && clientStatus === "In House" ? "Active" : clientStatus;

  const formatTimeString = (timeStr) => {
    if (!timeStr) return "";
    const [h, m] = timeStr.split(":").map(Number);
    const ampm = h >= 12 ? "PM" : "AM";
    const hour12 = h % 12 || 12;
    return `${hour12}:${m.toString().padStart(2, "0")} ${ampm}`;
  };

  const handleNavigate = () => {
    setShouldNavigate(true);
  };

  useEffect(() => {
    setFlashClientStatus(true);
    setTimeout(() => setFlashClientStatus(false), 500);
  }, [clientStatus]);

  useEffect(() => {
    setFlashAdmissionDate(true);
    setTimeout(() => setFlashAdmissionDate(false), 500);
  }, [admissionDate]);

  useEffect(() => {
    setFlashRoomNumber(true);
    setTimeout(() => setFlashRoomNumber(false), 500);
  }, [roomNumber]);

  useEffect(() => {
    setFlashTherapistName(true);
    setTimeout(() => setFlashTherapistName(false), 500);
  }, [therapistName]);

  useEffect(() => {
    setFlashSupportWorker(true);
    setTimeout(() => setFlashSupportWorker(false), 500);
  }, [supportWorker]);

  useEffect(() => {
    setFlashProjectedDischarge(true);
    setTimeout(() => setFlashProjectedDischarge(false), 500);
  }, [projectedDischarge]);

  useEffect(() => {
    setFlashPrimaryAddiction(true);
    setTimeout(() => setFlashPrimaryAddiction(false), 500);
  }, [primaryAddiction]);

  useEffect(() => {
    setFlashDurationOfStay(true);
    setTimeout(() => setFlashDurationOfStay(false), 500);
  }, [durationOfStay]);

  useEffect(() => {
    setFlashSwotDate(true);
    setTimeout(() => setFlashSwotDate(false), 500);
  }, [swotDate]);

  useEffect(() => {
    setFlashAlerts(true);
    setTimeout(() => setFlashAlerts(false), 500);
  }, [alerts]);

  // useEffect(() => {
  //   setFlashTherapistAppointment(true);
  //   const timeout = setTimeout(() => setFlashTherapistAppointment(false), 500);
  //   return () => clearTimeout(timeout);
  // }, [clientData.therapistAppointment]);
  useEffect(() => {
    setFlashTherapistAppointment(true);
    const timeout = setTimeout(() => setFlashTherapistAppointment(false), 500);
    return () => clearTimeout(timeout);
  }, [
    clientData.therapistAppointmentDays,
    clientData.therapistAppointmentTime,
  ]);

  useEffect(() => {
    setFlashSupportWorkerAppointment(true);
    //   const timeout = setTimeout(
    //     () => setFlashSupportWorkerAppointment(false),
    //     500
    //   );
    //   return () => clearTimeout(timeout);
    // }, [clientData.supportWorkerAppointment]);
    const timeout = setTimeout(
      () => setFlashSupportWorkerAppointment(false),
      500
    );
    return () => clearTimeout(timeout);
  }, [
    clientData.supportWorkerAppointmentDays,
    clientData.supportWorkerAppointmentTime,
  ]);

  useEffect(() => {
    setFlashMedicalAppointment(true);
    const timeout = setTimeout(() => setFlashMedicalAppointment(false), 500);
    return () => clearTimeout(timeout);
  }, [clientData.medicalAppointment]);

  useEffect(() => {
    setFlashVisaAppointment(true);
    const timeout = setTimeout(() => setFlashVisaAppointment(false), 500);
    return () => clearTimeout(timeout);
  }, [clientData.visaAppointment]);

  useEffect(() => {
    setFlashStepsAppointment(true);
    //   const timeout = setTimeout(() => setFlashStepsAppointment(false), 500);
    //   return () => clearTimeout(timeout);
    // }, [clientData.stepsAppointment]);
    const timeout = setTimeout(() => setFlashStepsAppointment(false), 500);
    return () => clearTimeout(timeout);
  }, [clientData.stepsAppointmentDays, clientData.stepsAppointmentTime]);

  useEffect(() => {
    setFlashMassageDay(true);
    const timeout = setTimeout(() => setFlashMassageDay(false), 500);
    return () => clearTimeout(timeout);
  }, [clientData.massageDay]);

  const getFlashStyle = (isActive) => ({
    backgroundColor: isActive ? "#899fc5" : "transparent",
    transition: "background-color 0.5s",
  });

  const formatDate = (timestamp) => {
    if (!timestamp || typeof timestamp.toDate !== "function") return "-";
    const date = timestamp.toDate();
    // Format personnalisable : ici, on affiche par exemple "dd MMM yyyy HH:mm"
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  React.useEffect(() => {
    if (shouldNavigate) {
      navigate(`/client/${idClient}`, {
        state: clientData, // Passez l'objet client complet
      });
    }
  }, [shouldNavigate]);

  return (
    <div
      style={{
        paddingLeft: "10px",
        cursor: "pointer",
        marginBottom: "5px",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleNavigate}
    >
      <div
        style={{
          width: "auto",
          display: "flex",
          flexDirection: "row",
          // justifyContent: "space-between",
          alignItems: "center",
          borderRadius: "5px",
          // padding: "10px",
          paddingLeft: "10px",
          color: "black",
          fontSize: "18px",
          fontWeight: "450",
          height: "60px",
          backgroundColor: isHovered ? "#d9e0ea" : "white",
          boxShadow:
            "0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1)",
        }}
      >
        <div
          style={{
            width: "60px",
            textAlign: "center",
          }}
        >
          {count}
        </div>

        <div
          style={{
            width: "120px",

            textAlign: "center",
            color: "white",
            ...getFlashStyle(flashClientStatus),
          }}
        >
          <span
            style={{
              width: "auto",
              paddingLeft: "5px",
              paddingRight: "5px",
              borderRadius: "5px",
              fontSize: "12px",
              backgroundColor:
                clientStatus === "In House"
                  ? "green"
                  : clientStatus === "Incoming"
                  ? "blue"
                  : "transparent",
            }}
          >
            {displayClientStatus}
          </span>
        </div>
        <div
          style={{
            width: "120px",
            textAlign: "center",
            fontSize: "12px",
          }}
        >
          {firstName + " " + lastName}
        </div>
        <div
          style={{
            width: "80px",
            textAlign: "center",
            ...getFlashStyle(flashRoomNumber),
          }}
        >
          {roomNumber}
        </div>

        <div
          style={{
            width: "100px",
            textAlign: "center",
            fontSize: "12px",

            ...getFlashStyle(flashTherapistName),
          }}
        >
          {therapistName}
        </div>

        {/* <div
          style={{
            width: "210px",
            textAlign: "center",
            ...getFlashStyle(flashTherapistName),
          }}
        >
          {therapistName}
        </div> */}
        {/* <div
          style={{
            width: "160px",
            fontSize: "12px",
            textAlign: "center",
            ...getFlashStyle(flashTherapistAppointment),
          }}
        >
          {clientData.therapistAppointment
            ? formatDate(clientData.therapistAppointment)
            : "-"}
        </div> */}

        <div
          style={{
            width: "160px",
            fontSize: "12px",
            textAlign: "center",
            ...getFlashStyle(flashTherapistAppointment),
          }}
        >
          {clientData.therapistAppointmentDays ||
          clientData.therapistAppointmentTime
            ? `${clientData.therapistAppointmentDays || ""} ${formatTimeString(
                clientData.therapistAppointmentTime
              )}`
            : "-"}
        </div>

        <div
          style={{
            width: "90px",
            textAlign: "center",
            fontSize: "12px",
            ...getFlashStyle(flashMassageDay),
          }}
        >
          {clientData.massageDay || "-"}
        </div>
        {/* <div style={textStyle}>{personalEmail}</div> */}
        <div
          style={{
            width: "160px",
            fontSize: "12px",
            textAlign: "center",
            ...getFlashStyle(flashSupportWorker),
          }}
        >
          {supportWorker}
        </div>

        <div
          style={{
            width: "180px",
            fontSize: "12px",
            textAlign: "center",
            ...getFlashStyle(flashSupportWorkerAppointment),
          }}
        >
          {/* {clientData.supportWorkerAppointment
            ? formatDate(clientData.supportWorkerAppointment)
            : "-"} */}
          {clientData.supportWorkerAppointmentDays ||
          clientData.supportWorkerAppointmentTime
            ? `${
                clientData.supportWorkerAppointmentDays || ""
              } ${formatTimeString(clientData.supportWorkerAppointmentTime)}`
            : "-"}
        </div>

        <div
          style={{
            width: "160px",
            fontSize: "12px",
            textAlign: "center",
            ...getFlashStyle(flashStepsAppointment),
          }}
        >
          {/* {clientData.stepsAppointment
            ? formatDate(clientData.stepsAppointment)
            : "-"} */}
          {clientData.stepsAppointmentDays || clientData.stepsAppointmentTime
            ? `${clientData.stepsAppointmentDays || ""} ${formatTimeString(
                clientData.stepsAppointmentTime
              )}`
            : "-"}
        </div>

        <div
          style={{
            width: "120px",
            fontSize: "12px",
            textAlign: "center",
            ...getFlashStyle(flashMedicalAppointment),
          }}
        >
          {clientData.medicalAppointment
            ? formatDate(clientData.medicalAppointment)
            : "-"}
        </div>
        <div
          style={{
            width: "120px",
            fontSize: "12px",
            textAlign: "center",
            ...getFlashStyle(flashVisaAppointment),
          }}
        >
          {clientData.visaAppointment
            ? formatDate(clientData.visaAppointment)
            : "-"}
        </div>

        <div
          style={{
            width: "120px",
            textAlign: "center",
            fontSize: "12px",
            ...getFlashStyle(flashAdmissionDate),
          }}
        >
          {admissionDate}
        </div>

        <div
          style={{
            width: "120px",
            textAlign: "center",
            fontSize: "12px",
            ...getFlashStyle(flashSwotDate),
          }}
        >
          {swotDate}
        </div>

        <div
          style={{
            width: "120px",
            textAlign: "center",
            fontSize: "12px",
            ...getFlashStyle(flashProjectedDischarge),
          }}
        >
          {projectedDischarge}
        </div>

        <div
          style={{
            width: "120px",
            textAlign: "center",
            ...getFlashStyle(flashDurationOfStay),
          }}
        >
          {durationOfStay}
        </div>

        {/* Colonne pour Massage Day */}
      </div>
    </div>
  );
}

export default ClientRowSupportDashboard;
